import { RoutePath } from '../../../enums/RoutePath';

export const VideosRoutes: RoutePath[] = [RoutePath.VideoTutorials, RoutePath.LatestVideos];
